module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_billingcontact", [["div",{"class":"site-page cancellation"},[["section",{"class":"about-wrapper"},[["div",{"class":"title-block"},[["div",{"class":"page-width"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Contact billing support"}]]]]]]]]],["div",{"class":"content-page cancellation-page"},[["div",{"class":"page-width"},[["p",{"class":"description"},[["textNode",{"text":"Address your questions to billing support team:"}]]],["div",{"class":"contact-form-wrapper"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/billingContact.tpl
// module id = 1077
// module chunks = 4